
const BannerData = {
  imageUrl:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fmain_d.avif?alt=media&token=fc2c86f3-8732-44c5-ba4e-86c3540ed318",
  mobileImageUrl:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FKVMobile.webp?alt=media&token=73d1e058-1457-4f64-aeb9-d5b471a7f6d1",
  title: "The Kia Syros EV",
  subtitle: "Superior beyond belief.",
  price: "₹ 13,49,900*",
  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FVehicle-1.webp?alt=media&token=3b665be2-62f4-44a6-9b24-d4fc6fc90c83",
      text: "Best in segment range 526 Kms^",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FOver-1.webp?alt=media&token=3b655809-3280-46a0-a061-1d24f8a65726",
      text: "Best in segment fast charging 10%-80% in just 39 mins#",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FADAS.webp?alt=media&token=688e4bd4-badb-4427-8b76-36794a5255ac",
      text: "Best in segment power 171 Ps",
    },
  ],
};

const BrochureLink =
  "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/syros/Kia_Syros_2025_Desktop.pdf";

const IntroData = {
  subheading: "RANGE",
  heading: "Best in Segment 526 km of Range. Zero Compromise.",
  description:
    "The Kia Syros EV pairs a best-in-segment 526 km* certified range with bold SUV design, advanced safety, and intuitive connectivity - built to remove every doubt that comes with going electric.",
};

const HighlightsData = {
  eyebrow: "HIGHLIGHTS",
  heading: "",
  description: "",
  reverse: false,
  items: [
    {
      title: "Best in Segment 171 PS Power. 39-Minute Charging",
      description:
        "A high-output electric motor delivering 171 PS of power, paired with best-in-segment fast charging that takes you from 10% to 80% in just 39 minutes.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FSuperior_Performance.avif?alt=media&token=29722a07-6790-4f2e-a3bd-57388523ee1a",
    },
    {
      title: "Ownership Confidence with Peace of Mind",
      description:
        "Assured Buy-Back, Battery-as-a-Service and a Lifetime High Voltage Battery Warranty come together to make EV ownership completely worry-free.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FSuperiorOwnership.avif?alt=media&token=ef9b321d-163a-4c9e-9652-9e5ea0568818",
    },
    {
      title: "Comfort beyond Segment. Space for everyone",
      description:
        "Enjoy best-in-segment 2nd row space, ventilated seats, a Dual Pane Panoramic Sunroof, 64-colour ambient mood lighting with LED footwell lamps (X-Line only), and a spacious 465L boot for every journey.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FSuperior_Comfort.avif?alt=media&token=1c8138e2-b34f-496b-8edb-e6889c7028eb",
    },
    {
      title: "First in Segment 76.20 cm Display. Total Connectivity",
      description:
        "The 76.20 cm (30”) Wide Trinity Panoramic Display brings navigation, infotainment and vehicle information together for a fully connected cockpit experience.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fpanaromic-display.avif?alt=media&token=18385905-9952-4bcf-ae78-426d598be0c3",
    },
  ],
};

const CircleData = [
  {
    title: "Ivory Silver Matte",
    color: "#c9c7bf",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d.avif?alt=media&token=2940b50d-4d07-46cb-ae43-3de7008ae9fe",
  },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d%20(1).avif?alt=media&token=cc9910fe-32da-4e75-85de-774e3d70b5ac",
  },
  {
    title: "Glacier White Pearl",
    color: "#f3f9fb",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d%20(3).avif?alt=media&token=0ffc8a7e-df7b-4eb8-ae04-57bfd2353563",
  },
  {
    title: "Gravity Grey",
    color: "#8f9599",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d.avif?alt=media&token=2940b50d-4d07-46cb-ae43-3de7008ae9fe",
  },
  {
    title: "Frost Blue",
    color: "#456274",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d%20(2).avif?alt=media&token=f072272c-2a5a-4d0e-9d8a-fd15055e3c1d",
  },
  {
    title: "Intense Red",
    color: "#b2001e",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d%20(4).avif?alt=media&token=be4307c1-1fde-4b43-8cd7-0cebadf3d182",
  },
  {
    title: "Pewter Olive",
    color: "#3e493b",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d%20(5).avif?alt=media&token=ded76721-6578-4f1d-bb84-4ccc223f7e03",
  },
];

const XLineCircleData = [
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/08-d%20(1).avif?alt=media&token=461f05a9-d55a-4c4e-a3fa-22c0c2f004af",
  },
  {
    title: "Gravity Grey",
    color: "#8f9599",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d-new.avif?alt=media&token=ca8acd58-7c81-4799-8fa8-151c40db5314",
  },
];

const TrimOptions = ["Tech Line", "X-Line"];

const CircleDataByTrim = {
  "Tech Line": CircleData,
  "X-Line": XLineCircleData,
};

const DetailShowcaseData = {
  eyebrow: "DETAIL",
  heading: "Superior in every detail.",
  description:
    "Explore the superior design, intuitive technology, and thoughtful innovations that come together to create an exceptional EV experience.",
  items: [
    {
      title: "Smart Dashcam with Dual Camera (With Mobile App)",
      description:
        "The Smart Dashcam with dual cameras records both front and rear views, while mobile app connectivity allows easy access to recordings and vehicle footage.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F1_d.mp4?alt=media&token=1b627c23-cfbd-4552-8414-40296eaf3ae5",
    },
    {
      title: '76.20 cm (30") Wide Trinity Panoramic Display Panel',
      description:
        "The 76.20 cm (30\") Wide Trinity Panoramic Display Panel seamlessly integrates essential driving, infotainment and vehicle information for a connected and immersive cockpit experience.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F2_d.mp4?alt=media&token=82305ab8-59e0-467e-b693-b8dac1f5467b",
    },
    {
      title: '12.7 cm (5") Touch Screen - Fully Automatic Temperature Control',
      description:
        "The 12.7 cm (5\") touchscreen interface lets you effortlessly manage cabin temperature, delivering personalised comfort with fully automatic climate control.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F3_d.mp4?alt=media&token=db19b93d-cf32-4d5c-a05e-5af40951253a",
    },
    {
      title: "Paddle Shifters for i-Pedal & Regen Braking",
      description:
        "Steering-mounted paddle shifters let you control regenerative braking with precision, while i-Pedal mode maximizes efficiency and one-pedal driving comfort.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F5_d.mp4?alt=media&token=a811cfec-c5a5-47da-b96e-d98f805a32d4",
    },
  ],
};

const ChargingData = {
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Ffast_charge.avif?alt=media&token=0ddfacb1-dffd-49cd-80bd-e22d02f44c33",
  heading: "Fast charging that keeps you moving",
  options: [
    {
      key: "dc",
      label: "DC Fast Charger",
      sub: "(100 kW)",
      headline: "10% to 80% in 39 minutes*",
      note: "Enough to grab a coffee",
    },
    {
      key: "ac",
      label: "AC Fast Charger",
      sub: "(11 kW)",
      headline: "10% to 100% in approx. 6 hours*",
      note: "Perfect for an overnight top-up at home",
    },
  ],
  disclaimer:
    "Disclaimer: *Depending on the condition of the high voltage battery, charger specifications, and ambient temperature, the time required for charging the high voltage battery may vary.",
};

const ConfidenceData = {
  eyebrow: "OWNERSHIP",
  heading: "Every Journey, Backed by Confidence.",
  description: "Everything you need to go electric.",
  reverse: true,
  items: [
    {
      title: "Assured Buy-Back",
      description:
        "Make EV ownership more rewarding with complete peace of mind through our industry-best Assured Buy-Back Program - up to 70% assured resale value by the end of 3 years, enhanced with an additional 10% introductory benefit*.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FA1.avif?alt=media&token=ac782f9a-2ca6-47ab-8a4e-84f4eeb986c0",
    },
    {
      title: "Battery as a Service (BaaS)",
      description:
        "Step into the world of electric mobility with an attractive Battery-as-a-Service (BaaS) programme starting with INR 7.99 lacs & battery EMI starting at INR 3.3/km^.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FA3.avif?alt=media&token=1275d3cf-9617-4eae-ba27-26041c788de8",
    },
    {
      title: "Lifetime Battery Warranty",
      description:
        "Backed by Lifetime High Voltage Battery Warranty** of 15 years with unlimited kilometres, delivering long-term battery confidence throughout ownership journey.",
      media:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FA2.avif?alt=media&token=10bbf113-d16d-41cf-b5f3-5a7d694254ff",
    },
  ],
  disclaimer:
    "*Limited period introductory offer till 30th Sep; Please check with your local Kia dealer for more details. Syros EV T&C applies ^ On Standard Range battery variant. Please check with your local Kia dealer for more details. Syros EV BaaS T&C applies.**For the first owners. Please check with your local Kia dealer for more details. Syros EV T&C applies",
};

const ExteriorShowcase = {
  eyebrow: "EXTERIOR",
  heading: "Superior by design. Distinctive by nature.",
  description:
    "A striking SUV silhouette, futuristic lighting signatures, and thoughtful design details come together to create a superior road presence.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fexterior_1.avif?alt=media&token=2358b415-4566-47d7-9342-1fe5639b2ba8",
      title: "Ice Cube MFR LED Headlamps with Starmap LED DRLs",
      subtitle: "Precision lighting that blends a futuristic vision with striking style.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fexterior_3.avif?alt=media&token=7f111678-7fbf-4fcd-9235-17e267d6cc22",
      title: "Starmap LED Tail Lamps",
      subtitle: "A signature look that lights the way, leaving an indelible impression.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fexterior_9.avif?alt=media&token=90702694-9921-4f06-b685-37b01f912243",
      title: "Streamline Door Handles",
      subtitle: "A first-in-segment touch of the future, making access as smooth as the design.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fexterior_4.avif?alt=media&token=7f30cddb-06d7-407e-bbba-5e8ef726689b",
      title: 'R17 - 43.66 cm (17”) Crystal Cut Dual Tone Aero Alloy Wheels',
      subtitle: "Turning heads and tackling terrain, with wheels that stand tall.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fexterior_5.avif?alt=media&token=03baa8a9-e5fa-4913-abad-92d0e2557398",
      title: "Kia Signature Digital Tiger Face",
      subtitle: "A bold statement of otherworldly presence that mesmerizes.",
    },
  ],
};

const InteriorShowcase = {
  eyebrow: "INTERIOR",
  heading: "A cabin crafted around you.",
  description:
    "Thoughtfully designed with advanced technology, premium finishes, and exceptional space to make every journey not only superior but also comfortable.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Finterior_1.avif?alt=media&token=2428cebb-121c-4a50-a4f2-e7bbb63f91a8",
      title: "Dual Pane Panoramic Sunroof",
      subtitle: "Expands your world with a view that bridges the present and the possibilities ahead.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Finterior_2.avif?alt=media&token=4bb20176-78e1-4463-90bb-00293889b9ee",
      title: "EV Shift-by-Wire Selector with Electric Parking Brake",
      subtitle: "Seamless drive mode selection with Auto Hold, decluttering the console for a modern feel.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Finterior_3.avif?alt=media&token=450a0aac-b507-48ca-88ac-e17cecb5f96a",
      title: "Harman Kardon Premium 8 Speakers Sound System",
      subtitle: "Experience sound like never before, with unparalleled precision and depth.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Finterior_4.avif?alt=media&token=9d110d86-cb7f-41da-b5fb-0d45d80e3426",
      title: "64 Colour Ambient Mood Lighting",
      subtitle: "Illuminates the cabin with a mood that evolves with you, from night to day.",
    },
  ],
};

const SafetyShowcase = {
  eyebrow: "SAFETY",
  heading: "Superior confidence comes standard.",
  description:
    "Engineered with advanced safety technologies and intelligent driver assistance systems to help keep you protected on every drive.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fairbag.avif?alt=media&token=9ae89527-698a-42ce-9b3d-21a643e1aea0",
      title: "6 Airbags as Standard",
      subtitle: "Guarding you with six points of defense, always.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fsafety_2.avif?alt=media&token=2e218d8e-69fd-47b4-a5ff-2002f24161d5",
      title: "Front and Rear Parking Sensors",
      subtitle: "4 parking sensors each at the front and rear that guide you into the tightest spots.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fsafety_3.avif?alt=media&token=92ffd994-8c54-4199-a593-f2c0299fa4ba",
      title: "ESS (Emergency Stop Signal)",
      subtitle: "Ensures you're visible to others when you need to stop fast.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fhillasct.avif?alt=media&token=b27ea37c-a371-433a-be60-308e8c84935b",
      title: "Highline Tyre Pressure Monitor",
      subtitle: "Monitors your tyre pressure for a smoother, safer drive.",
    },
  ],
};

const AdasShowcase = {
  eyebrow: "ADAS",
  heading: "Smarter awareness. Safer journeys.",
  description:
    "Advanced Driver Assistance Systems work seamlessly in the background, helping you navigate every road with greater confidence and peace of mind.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FFC_Pedestrian_Desktop.mp4?alt=media&token=29c7f99e-48ed-455f-acf0-344636b1e870",
      title: "Smart Cruise Control with Stop & Go",
      subtitle: "Automatically maintains distance and manages stop-and-go traffic.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FSCC_Desktop.mp4?alt=media&token=9d89a57d-9fcc-4d80-b134-79c9d5480532",
      title: "Front Collision-Avoidance Assist - Junction Turning",
      subtitle: "Helps prevent accidents at intersections by assisting with braking.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FLane_keep.mp4?alt=media&token=20173c1a-c8a6-477e-9e91-106d7b9bfbcc",
      title: "High Beam Assist",
      subtitle: "Automatically switches between high and low beams for better visibility.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FHBA_Desktop.mp4?alt=media&token=2b9b48a8-0778-427f-82f0-46f94650c1fd",
      title: "360 Degree Camera",
      subtitle: "Offers a full view around the car to assist in parking.",
    },
  ],
};

const ComfortShowcase = {
  eyebrow: "COMFORT & CONVENIENCE",
  heading: "Designed for effortless everyday living.",
  description:
    "From connected technologies to thoughtful comfort features, every detail is crafted to make every journey simpler, smarter, and more enjoyable.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2FFrontRear.avif?alt=media&token=ed2c8f44-6994-4d70-9b6d-b88a23be8dc3",
      title: "Ventilated Front Seats",
      subtitle: "Stay cool and comfortable no matter the weather outside.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcomfort_2.avif?alt=media&token=fe2a9bce-fac7-49f2-851e-c2b5ef3c69ee",
      title: "Second Row Seat Recline & Slide",
      subtitle: "First-in-segment innovation, designed to deliver unmatched comfort for every journey.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcomfort_3.avif?alt=media&token=2ebdf3c9-ef1c-4b05-90c2-f2198a308107",
      title: "Electric Parking Brake with Auto Hold",
      subtitle: "Holds the brake in place, giving you complete control at every stop.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcomfort_11.avif?alt=media&token=c93cbe5a-e838-4553-9e29-2eabc92b2658",
      title: "60:40 Split Rear Seats with Center Armrest",
      subtitle: "Flexible seating that adapts to passengers and cargo alike.",
    },
  ],
};

const ConnectivityShowcase = {
  eyebrow: "CONNECTIVITY",
  heading: "Always supported. Always connected.",
  description:
    "The next-gen Kia Connect puts control at your fingertips with 95+ smart connected features designed to make every drive simpler.",
  slides: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcone_1.avif?alt=media&token=0d6df4be-300f-443f-9698-9b9af38b9d73",
      title: "Kia Remote Diagnostics",
      subtitle: "Remotely diagnose and resolve issues with Kia's service team.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcone_2.avif?alt=media&token=8f4b1798-abfc-4ae7-8e51-956fbd0f4a74",
      title: "Wake-up Command",
      subtitle: "With one command, your car comes to life, ready to take you places.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcone_3.avif?alt=media&token=2009e8a5-1b85-4ab5-9d37-3e42ede1a026",
      title: "Multilingual VR Commands",
      subtitle: "Navigate seamlessly with voice commands in multiple languages.",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2Fcone_4.avif?alt=media&token=d6a1cca7-a092-4c97-a455-ae8c6bd744bf",
      title: "Call Center Assisted Navigation",
      subtitle: "Connect instantly with our call center for on-the-spot navigation assistance.",
    },
  ],
};

const VariantData = [
  {
    name: "HTK",
    price: "13,49,900",
    colors: ["#c9c7bf", "#456274", "#f3f9fb", "#3e493b", "#8f9599", "#b2001e", "#e0e0df", "#151617"],
    features: [
      '76.20cm (30") Wide Trinity Panoramic Display Panel',
      'R16 - 40.56 cm (16”) Crystal Cut Dual Tone Aero Alloy Wheels',
      "Shift-by-Wire (SBW)",
      "Electric Parking Brake (EPB) with Auto-Hold",
      "Star Map LED DRL, ICE Cube MFR LED Headlamps & LED Front Fog Lamps",
      "Starmap LED Combination Tail Lamps",
      "Standard 25 Hi Safety Package",
    ],
  },
  {
    name: "HTK+",
    price: "14,99,900",
    colors: ["#c9c7bf", "#151617", "#f3f9fb", "#3e493b", "#8f9599", "#151617", "#b2001e", "#456274"],
    features: [
      '76.20cm (30") Wide Trinity Panoramic Display Panel',
      'R16 - 40.56 cm (16”) Crystal Cut Dual Tone Aero Alloy Wheels',
      "Star Map LED DRL, ICE Cube MFR LED Headlamps & LED Front Fog Lamps",
      "Starmap LED Combination Tail Lamps",
      "Cruise Control with Manual Speed Limit Assist",
      "100W C-Type USB Charger (Front x 1)",
      "Rear View Camera with Dynamic Guidelines",
    ],
  },
  {
    name: "HTX",
    price: "15,99,900",
    colors: ["#c9c7bf", "#8f9599", "#456274", "#f3f9fb", "#151617", "#3e493b", "#b2001e"],
    features: [
      "Dual Pane Panoramic Sunroof",
      "60:40 Split Rear Seats with Sliding, Reclining Function & Center Armrest",
      '76.20cm (30") Wide Trinity Panoramic Display Panel',
      'R16 - 40.56 cm (16”) Crystal Cut Dual Tone Aero Alloy Wheels',
      "All Door Power Windows Up/Down with Smart Key & Safety",
      "Rear Wiper & Washer",
      "Rear Defogger",
    ],
  },
  {
    name: "HTK+ ER",
    price: "16,99,900",
    colors: ["#c9c7bf", "#f3f9fb", "#b2001e", "#3e493b", "#151617", "#456274", "#8f9599"],
    features: [
      '76.20cm (30") Wide Trinity Panoramic Display Panel',
      'R17 - 43.66 cm (17”) Crystal Cut Dual Tone Aero Alloy Wheels',
      "Star Map LED DRL, ICE Cube MFR LED Headlamps & LED Front Fog Lamps",
      "Starmap LED Combination Tail Lamps",
      "Cruise Control with Manual Speed Limit Assist",
      "100W C-Type USB Charger (Front x 1)",
      "Rear View Camera with Dynamic Guidelines",
    ],
  },
  {
    name: "HTX+ ER",
    price: "18,49,900",
    colors: ["#c9c7bf", "#151617", "#456274", "#b2001e", "#3e493b", "#f3f9fb", "#8f9599"],
    features: [
      "Dual Pane Panoramic Sunroof",
      "64-Colour Ambient Mood Lighting with LED Footwell Lamps",
      "Ventilated Front Seats",
      "Harman Kardon Premium 8 Speakers Sound System",
      "Smart Dashcam with Dual Camera (With Mobile App)",
      "Kia Connect 2.0 with 95+ Connected Features",
      "ADAS Level 2 Package",
    ],
  },
];

const TrimData = VariantData.map((v) => ({
  title: v.name,
  cost: v.price,
  feature1: v.features[0],
  feature2: v.features[1],
  feature3: v.features[2],
  feature4: v.features[3],
  feature5: v.features[4],
  feature6: v.features[5],
  feature7: v.features[6] || "",
}));

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book Your Syros EV Today",
    desc: "It's time to own the most superior Kia EV yet",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Learn more about its wild possibilities",
    link: BrochureLink,
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 1800 108 5000",
    link: "tel:+911800108500",
  },
];

const FaqData = [
  {
    question: "What is the certified range of the Kia Syros EV?",
    answer:
      "The Kia Syros EV offers a best-in-segment certified range of 526 km^ (as per ARAI MIDC-Full) on a single charge.",
  },
  {
    question: "How fast can the Kia Syros EV charge?",
    answer:
      "Using a 100 kW DC Fast Charger, the Syros EV charges from 10% to 80% in just 39 minutes#. On an 11 kW AC charger, a full charge takes approximately 6 hours.",
  },
  {
    question: "What warranty does the Syros EV battery come with?",
    answer:
      "The Syros EV is backed by a Lifetime High Voltage Battery Warranty of 15 years with unlimited kilometres for first owners.",
  },
  {
    question: "Does the Kia Syros EV offer a Buy-Back program?",
    answer:
      "Yes, the Assured Buy-Back Program offers up to 70% assured resale value by the end of 3 years, with an additional 10% introductory benefit for a limited period.",
  },
  {
    question: "What is Battery as a Service (BaaS) for the Syros EV?",
    answer:
      "BaaS lets you purchase the Syros EV starting at INR 7.99 lacs (excluding battery) with a battery EMI starting at INR 3.3/km on the Standard Range variant.",
  },
];

export {
  BannerData,
  BrochureLink,
  IntroData,
  HighlightsData,
  CircleData,
  CircleDataByTrim,
  TrimOptions,
  DetailShowcaseData,
  ChargingData,
  ConfidenceData,
  ExteriorShowcase,
  InteriorShowcase,
  SafetyShowcase,
  AdasShowcase,
  ComfortShowcase,
  ConnectivityShowcase,
  VariantData,
  TrimData,
  DetailInfo,
  FaqData,
};
